function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genMultipleChoiceStyles = function genMultipleChoiceStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '4px'
  }, ".readOnly", _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }, ".name", _defineProperty(_defineProperty({
    minWidth: '0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    color: '#3D414D'
  }, ".label", {
    minWidth: '0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }), ".count", {
    flexShrink: 0,
    paddingRight: '12px'
  }))), ".placeholder", {
    color: ' #9ea0a6',
    fontSize: '14px',
    fontWeight: 400
  }), ".batchPicker", _defineProperty(_defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '4px 12px',
    border: '1px solid #E1E1E7',
    borderRadius: '2px',
    backgroundColor: '#fff'
  }, ".name", _defineProperty(_defineProperty({
    minWidth: '0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    color: '#3D414D'
  }, ".label", {
    minWidth: '0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }), ".count", {
    flexShrink: 0,
    paddingRight: '12px'
  })), ".suffix", _defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }, ".downIcon:hover", {
    opacity: 0.6
  }), ".clearButton", _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e5e7eb',
    borderRadius: '50%',
    width: '12px',
    height: '12px'
  }, ".icon", {
    width: '8px',
    height: '8px'
  })), ".clearButton:hover", {
    opacity: 0.6
  }))), '.disabled', _defineProperty({
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    color: 'rgba(0, 0, 0, 0.25)',
    borderColor: '#d9d9d9',
    boxShadow: 'none',
    cursor: 'not-allowed',
    opacity: 1
  }, ".name", {
    color: 'rgba(0, 0, 0, 0.25)'
  })))];
};